/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactDTO
 */
export interface ContactDTO {
    /**
     * 
     * @type {string}
     * @memberof ContactDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDTO
     */
    telephoneNumber?: string;
}

export function ContactDTOFromJSON(json: any): ContactDTO {
    return ContactDTOFromJSONTyped(json, false);
}

export function ContactDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'telephoneNumber': !exists(json, 'telephoneNumber') ? undefined : json['telephoneNumber'],
    };
}

export function ContactDTOToJSON(value?: ContactDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'email': value.email,
        'telephoneNumber': value.telephoneNumber,
    };
}

